(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joanna-product-inquiry"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-jh-gallery-thumbnail]');
    if (!thumbnail) return;
    const gallery = thumbnail.closest('.jh-product__gallery');
    const heroImage = gallery?.querySelector('.jh-product__hero-image');
    if (!heroImage) return;
    heroImage.src = thumbnail.dataset.imageSrc;
    heroImage.removeAttribute('srcset');
    heroImage.alt = thumbnail.dataset.imageAlt || '';
    gallery.querySelectorAll('[data-jh-gallery-thumbnail]').forEach((button) => button.removeAttribute('aria-current'));
    thumbnail.setAttribute('aria-current', 'true');
  });

  } catch(e) { console.error(e); }
})();
})();
